import { createContext } from "react";

const LocationContext = createContext();

export const { Provider } = LocationContext;

export default LocationContext;
